import { TextSelection, } from 'prosemirror-state';
export const resetLeadingTextBlock = (state, dispatch) => {
    var _a, _b, _c, _d;
    const { doc, tr, selection, schema } = state;
    if (((_a = doc.firstChild) === null || _a === void 0 ? void 0 : _a.isTextblock) &&
        (((_b = doc.firstChild) === null || _b === void 0 ? void 0 : _b.type.name) !== 'paragraph' ||
            Object.keys((_c = doc.firstChild) === null || _c === void 0 ? void 0 : _c.attrs).some((key) => { var _a; return ((_a = doc.firstChild) === null || _a === void 0 ? void 0 : _a.attrs[key]) != null; })) &&
        ((_d = doc.firstChild) === null || _d === void 0 ? void 0 : _d.childCount) === 0 &&
        selection.from === 1 &&
        selection.empty) {
        if (doc.canReplaceWith(0, 1, schema.nodes.paragraph)) {
            tr.replaceWith(0, 1, schema.nodes.paragraph.create());
            tr.setSelection(TextSelection.create(tr.doc, 1, 1));
        }
        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
        return true;
    }
    return false;
};
//# sourceMappingURL=resetLeadingTextBlock.js.map